export function OutlinePercentageIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00304 11.0055C9.66157 11.0055 11.0061 9.43726 11.0061 7.50275C11.0061 5.56823 9.66157 4 8.00304 4C6.34451 4 5 5.56823 5 7.50275C5 9.43726 6.34451 11.0055 8.00304 11.0055Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M18.0116 19.0153C19.6701 19.0153 21.0146 17.447 21.0146 15.5125C21.0146 13.578 19.6701 12.0098 18.0116 12.0098C16.3531 12.0098 15.0085 13.578 15.0085 15.5125C15.0085 17.447 16.3531 19.0153 18.0116 19.0153Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M7.00366 19.0161L19.0158 4.05859"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
}
